module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_3_m.a823515e20454393f9299648290880fb.png";